import axios from "axios";
import environment from "../environment";
import {tokenService} from "./token.service";
import {customHistory} from "../App";

export const enum USER_TYPE {
  ADMIN = "admin",
  CONSULTANT = "consultant",
  PARTNER_MANAGER = "partnermanager"
}

async function validateToken(userType: USER_TYPE) {
  const currentToken = await new tokenService().get(userType);
  // //console.log("currentToken", currentToken);
  if (!currentToken) return false;

  let serverRes;
  const DEFAULT_HEADERS = {
    Authorization: currentToken ? `Bearer ${currentToken.token}` : null,
    "app-version": "1.0.1"
  };
  try {
    // Verify token by server
    switch (userType) {
      case USER_TYPE.ADMIN:
        serverRes = await axios({
          method: "GET",
          url:
            (environment.baseUrl === "https://api.taxefy.at/api/" ? "https://client.taxefy.at/" : "https://client-dev.taxefy.at/") +
            "admin/verifyToken",
          headers: DEFAULT_HEADERS
        });
        break;
      case USER_TYPE.CONSULTANT:
        serverRes = await axios({
          method: "GET",
          url: environment.baseUrl + "consultant/auth/verifyToken",
          headers: DEFAULT_HEADERS
        });
        break;
      case USER_TYPE.PARTNER_MANAGER:
        serverRes = await axios({
          method: "GET",
          url: environment.baseUrl + "partnermanager/verifyToken",
          headers: DEFAULT_HEADERS
        });
        break;
    }

    // //console.log(serverRes);

    if (serverRes.data.expired) return false;
    return currentToken;
  } catch (error) {
    return false;
  }
}

export interface apiRequest {
  endpoint: string;
  method: any;
  userType: USER_TYPE;
  needsToken: boolean;
  data: any;
  params: any;
  headers?: any;
  responseType?: any;
}

export async function callAPI(data: apiRequest) {
  try {
    const token = await validateToken(data.userType);
    if (!token && data.needsToken) {
      await new tokenService().remove(data.userType);
      customHistory.push(`/${data.userType}/auth/login`);
      (customHistory as any).showError("Sitzung ist abgelaufen");
      return {
        status: false,
        data: "Token expired"
      };
    }

    const DEFAULT_HEADERS = {
      Authorization: token ? `Bearer ${token.token}` : null,
      "app-version": "1.0.1"
    };

    let finalUrl = environment.baseUrl + data.endpoint;

    if (data.endpoint === "auth/activateUser") {
      if (environment.baseUrl === "https://api.taxefy.at/api/") {
        finalUrl = "https://client.taxefy.at/activateUser";
      } else {
        finalUrl = "https://client-dev.taxefy.at/activateUser";
      }
    }

    if (data.endpoint.includes("admin/auth")) {
      if (environment.baseUrl === "https://api.taxefy.at/api/") {
        finalUrl = `https://client.taxefy.at/${data.endpoint.replace("admin/auth", "admin")}`;
      } else {
        finalUrl = `https://client-dev.taxefy.at/${data.endpoint.replace("admin/auth", "admin")}`;
      }
    }

    const result = await axios({
      method: data.method,
      url: finalUrl,
      headers: data.headers ? {...DEFAULT_HEADERS, ...data.headers} : DEFAULT_HEADERS,
      data: data.data,
      params: data.params,
      responseType: data.responseType || "text",
      withCredentials: false
    });

    return {
      status: true,
      data: result.data
    };
  } catch (error: any) {
    (customHistory as any).showError(`Ein Fehler ist aufgetreten: ${error.request.response}`);
    return {
      status: false,
      data: error
    };
  }
}
